import { signal } from "@preact/signals-react"

export const country = signal([])
export const retailer = signal([])
export const secondRetailer = signal(null)
export const keyword = signal([])
export const dashboard = signal([])
export const seller = signal([])